import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1B365D',
      light: '#2E4A7A',
      dark: '#122440',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00B894',
      light: '#33C6A9',
      dark: '#008F72',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1B365D',
      secondary: '#5A6A85',
    },
    divider: '#E0E5EC',
    success: {
      main: '#00B894',
    },
    error: {
      main: '#E74C3C',
    },
    warning: {
      main: '#F39C12',
    },
    info: {
      main: '#3498DB',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.25rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.875rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.1rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  shadows: [
    'none',
    '0px 1px 3px rgba(27, 54, 93, 0.08)',
    '0px 2px 6px rgba(27, 54, 93, 0.10)',
    '0px 4px 12px rgba(27, 54, 93, 0.12)',
    '0px 6px 16px rgba(27, 54, 93, 0.14)',
    '0px 8px 24px rgba(27, 54, 93, 0.16)',
    '0px 12px 32px rgba(27, 54, 93, 0.18)',
    ...Array(18).fill('0px 12px 32px rgba(27, 54, 93, 0.18)'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 20px',
          fontSize: '0.9rem',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 8px rgba(27, 54, 93, 0.15)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1B365D 0%, #2E4A7A 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #122440 0%, #1B365D 100%)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(135deg, #00B894 0%, #33C6A9 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #008F72 0%, #00B894 100%)',
          },
        },
        outlined: {
          borderWidth: 1.5,
          '&:hover': {
            borderWidth: 1.5,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 2px 8px rgba(27, 54, 93, 0.08)',
          border: '1px solid #E0E5EC',
          transition: 'box-shadow 0.2s ease-in-out',
          '&:hover': {
            boxShadow: '0px 4px 16px rgba(27, 54, 93, 0.12)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
        elevation1: {
          boxShadow: '0px 2px 8px rgba(27, 54, 93, 0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0px 1px 4px rgba(27, 54, 93, 0.10)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 600,
            backgroundColor: '#F5F7FA',
            color: '#1B365D',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid #E0E5EC',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginBottom: 4,
          '&.Mui-selected': {
            backgroundColor: 'rgba(27, 54, 93, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(27, 54, 93, 0.12)',
            },
          },
        },
      },
    },
  },
});

export default theme;
